import React, { useEffect, useState } from 'react';
import { MoreHorizontal, PhoneIncoming, PhoneOutgoing } from 'lucide-react';
import { prettyNumber } from '../../CallDialog';
import { formatTime } from '../../ui';
import { callDay, formatDuration } from '../callModel';
import { CallStatus } from './CallBadges';

const initial = (c) => (c.contact_name || '#').trim()[0].toUpperCase();
const TONES = ['blue', 'purple', 'green', 'gold', 'red', 'teal'];
const tone = (c) => TONES[[...(c.contact_name || c.other_number || '')].reduce((n, ch) => n + ch.charCodeAt(0), 0) % TONES.length];

function RowMenu({ call, at, canCall, onAction, onClose }) {
  useEffect(() => {
    const close = () => onClose();
    window.addEventListener('click', close);
    window.addEventListener('scroll', close, true);
    return () => { window.removeEventListener('click', close); window.removeEventListener('scroll', close, true); };
  }, [onClose]);
  const items = [['view', 'View details'], ['open', 'Open full call page'], canCall && ['call', 'Call back'], ['copy', 'Copy number']].filter(Boolean);
  return (
    <div className="cl-menu" style={{ top: at.y, left: at.x }} role="menu" onClick={(e) => e.stopPropagation()}>
      {items.map(([k, label]) => <button key={k} type="button" role="menuitem" onClick={() => { onClose(); onAction(k, call); }}>{label}</button>)}
    </div>
  );
}

/** Call history: caller, direction, team member, duration, outcome, time and actions; a row opens it on the right. */
export default function CallsTable({ calls, offset, activeId, canCall, onView, onAction }) {
  const [menu, setMenu] = useState(null);
  return (
    <div className="table-scroll">
      <table className="full-page-table cl-table">
        <thead><tr><th>#</th><th>Caller</th><th>Direction</th><th>Team member</th><th>Duration</th><th>Status</th><th>Time</th><th>Actions</th></tr></thead>
        <tbody>
          {calls.map((c, i) => (
            <tr key={c.id} className={c.id === activeId ? 'active' : ''} onClick={() => onView(c)}>
              <td className="cell-muted">{offset + i + 1}</td>
              <td><span className="cl-caller"><span className={`cl-avatar ${tone(c)}`}>{initial(c)}</span>
                <span><b>{c.contact_name || prettyNumber(c.other_number)}</b><small>{c.contact_name ? prettyNumber(c.other_number) : 'Not in contacts'}</small></span></span></td>
              <td><span className={c.direction === 'inbound' ? 'type-incoming' : 'type-outgoing'}>
                {c.direction === 'inbound' ? <PhoneIncoming size={12} /> : <PhoneOutgoing size={12} />}{c.direction === 'inbound' ? 'Incoming' : 'Outgoing'}
              </span></td>
              <td>{c.user_name || '—'}</td>
              <td>{formatDuration(c.duration_seconds)}</td>
              <td><CallStatus status={c.status} /></td>
              <td className="cl-when">{callDay(c.started_at)}<small>{formatTime(c.started_at)}</small></td>
              <td>
                <span className="cl-row-actions">
                  <button type="button" className="row-action" onClick={(e) => { e.stopPropagation(); onView(c); }}>View</button>
                  <button type="button" className="cl-icon-btn" aria-label="More actions"
                    onClick={(e) => { e.stopPropagation(); const r = e.currentTarget.getBoundingClientRect(); setMenu({ call: c, at: { x: Math.max(8, r.right - 190), y: Math.min(r.bottom + 4, window.innerHeight - 180) } }); }}>
                    <MoreHorizontal size={14} /></button>
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {menu && <RowMenu call={menu.call} at={menu.at} canCall={canCall} onAction={onAction} onClose={() => setMenu(null)} />}
    </div>
  );
}
